/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TSaveUserEstimationScoreFactRequest,
  TSaveUserEstimationScoreFactModel,
  IMappers,
  TSaveUserEstimationScoreFactResponse,
  TSaveUserEstimationScoreFactResponseData200,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createSaveUserEstimationScoreFactModel(
  parameters: TSaveUserEstimationScoreFactRequest,
): TSaveUserEstimationScoreFactModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'price-estimator',
    pathApi: '/v1/save-user-estimation-score-fact/',
    response: {
      200: {},
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface ISaveUserEstimationScoreFactOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TSaveUserEstimationScoreFactRequest;
}

export async function fetchSaveUserEstimationScoreFact<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ISaveUserEstimationScoreFactOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TSaveUserEstimationScoreFactResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createSaveUserEstimationScoreFactModel(parameters),
    config,
  )) as FetchResponse<TSaveUserEstimationScoreFactResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TSaveUserEstimationScoreFactResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TSaveUserEstimationScoreFactResponse>;
}
